import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
})

export class BlogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
